<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          {{ isEdit ? "Update Transfusion" : "Add Transfusion" }}
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form @submit.prevent="saveTransfusion">
          <div class="row mb-3">
            <div class="col-md-6">
              <label>Blood Group:</label>
              <select v-model="form.blood_group" class="form-control" required>
                <option disabled value="">Select</option>
                <option>A+</option>
                <option>A-</option>
                <option>B+</option>
                <option>B-</option>
                <option>AB+</option>
                <option>AB-</option>
                <option>O+</option>
                <option>O-</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Component:</label>
              <select v-model="form.component" class="form-control" required>
                <option disabled value="">Select</option>
                <option>Whole Blood</option>
                <option>Plasma</option>
                <option>Platelets</option>
                <option>Red Cells</option>
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <label>Volume (ml):</label>
              <input
                type="number"
                v-model="form.volume_ml"
                class="form-control"
                min="50"
                required
              />
            </div>
            <div class="col-md-6">
              <label>Date & Time:</label>
              <input
                type="datetime-local"
                v-model="form.transfusion_date"
                class="form-control"
                required
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <label>Status:</label>
              <select v-model="form.status" class="form-control">
                <option value="pending">Pending</option>
                <option value="ongoing">Ongoing</option>
                <option value="completed">Completed</option>
              </select>
            </div>
            <div class="col-md-6">
              <label>Notes:</label>
              <textarea
                v-model="form.notes"
                class="form-control"
                rows="2"
                placeholder="Optional notes"
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Close
        </button>
        <button type="button" class="btn btn-primary" @click="saveTransfusion">
          {{ isEdit ? "Update" : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "TransfusionModal",
  props: {
    transfusion: {
      type: Object,
      default: null,
    },
    visit_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      form: {
        blood_group: "",
        component: "",
        volume_ml: "",
        transfusion_date: "",
        status: "pending",
        notes: "",
        visit_id: this.visit_id,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.transfusion;
    },
  },
  mounted() {
    if (this.transfusion) {
      this.form = { ...this.transfusion };
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-transfusion-mod");
    },
    async saveTransfusion() {
      const url = "transfusions";
      const body = this.form;
      // console.log(body);
      const resp = await generalApiRequest(url, "POST", body, 1);
      console.log(resp);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.mmodal-content {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  border-top: 1px solid #ddd;
  justify-content: flex-end;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
